import { render, staticRenderFns } from "./PurchaseResult.vue?vue&type=template&id=c12d7cf8&scoped=true&"
import script from "./PurchaseResult.vue?vue&type=script&lang=js&"
export * from "./PurchaseResult.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseResult.vue?vue&type=style&index=0&id=c12d7cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d7cf8",
  null
  
)

export default component.exports